const brand = {
  infiiot: "assets/img/Collaborations/infiiot_logo.png",
  ni2: "assets/img/Collaborations/ni2_logo.png",
  skylark: "assets/img/Collaborations/skylark_logo.png",
  revolution: "assets/img/Collaborations/revolution_logo.png"
};
module.exports = brand;
